const BetsModule = () => import(/* webpackChunkName: "bets-module" */ './views/Module.vue');
const Bets = () => import(/* webpackChunkName: "bets" */ './views/Bets.vue');
const WinLoss = () => import(/* webpackChunkName: "win-loss" */ './views/WinLoss.vue');
const WinLossDetail = () => import(/* webpackChunkName: "profit-loss" */ './views/WinLossDetail.vue');

const BetsRoutes = {
    path: '/',
    component: BetsModule,
    children: [
        {
            path: 'bets/:type',
            name: 'bets',
            component: Bets,
        },
        {
            path: 'win-loss',
            name: 'win-loss',
            component: WinLoss,
        },
        {
            path: 'win-loss-detail',
            name: 'WinLossDetail',
            component: WinLossDetail
        }
    ],
}

export default BetsRoutes;